<div class="billing-page" rtlDiv>

  <!-- Sidebar — same design as main sidebar, billing items only -->
  <div class="billing-sidebar">
    <div class="sidebar-nav">

      <!-- Top: logo + nav items -->
      <div>
        <div class="logo">
          <img class="databin-logo" src="assets/images/topmenu/databinlogo.svg" alt="" />
        </div>

        <!-- Back link -->
        <div class="billing-back-row" (click)="goBack()">
          <img src="assets/images/billing/back_arrow.svg" class="back-icon" rtlDiv alt="" />
          <span>{{ 'BILLING.TITLE' | translate }}</span>
        </div>

        <!-- Nav items — replicating sidebar-item structure exactly -->
        <div class="billing-routes">

          <div class="billing-nav-item" [class.active]="activeView === 'overview'" (click)="activeView = 'overview'">
            <div class="sidebar-item-container">
              <div class="icon-caption">
                <svg class="routerlink-img" width="20" height="20" viewBox="0 0 16 16" fill="none">
                  <rect x="1" y="1" width="6" height="6" rx="1" [attr.fill]="activeView === 'overview' ? '#28B365' : '#9B9B9B'"/>
                  <rect x="9" y="1" width="6" height="6" rx="1" [attr.fill]="activeView === 'overview' ? '#28B365' : '#9B9B9B'"/>
                  <rect x="1" y="9" width="6" height="6" rx="1" [attr.fill]="activeView === 'overview' ? '#28B365' : '#9B9B9B'"/>
                  <rect x="9" y="9" width="6" height="6" rx="1" [attr.fill]="activeView === 'overview' ? '#28B365' : '#9B9B9B'"/>
                </svg>
                <div class="label"><span>{{ 'BILLING.OVERVIEW' | translate }}</span></div>
              </div>
            </div>
          </div>

          <div class="billing-nav-item" [class.active]="activeView === 'invoices'" (click)="activeView = 'invoices'">
            <div class="sidebar-item-container">
              <div class="icon-caption">
                <svg class="routerlink-img" width="20" height="20" viewBox="0 0 16 16" fill="none">
                  <rect x="2" y="2" width="12" height="12" rx="1" [attr.stroke]="activeView === 'invoices' ? '#28B365' : '#9B9B9B'" stroke-width="1.5"/>
                  <line x1="5" y1="6" x2="11" y2="6" [attr.stroke]="activeView === 'invoices' ? '#28B365' : '#9B9B9B'" stroke-width="1.2"/>
                  <line x1="5" y1="8.5" x2="11" y2="8.5" [attr.stroke]="activeView === 'invoices' ? '#28B365' : '#9B9B9B'" stroke-width="1.2"/>
                  <line x1="5" y1="11" x2="9" y2="11" [attr.stroke]="activeView === 'invoices' ? '#28B365' : '#9B9B9B'" stroke-width="1.2"/>
                </svg>
                <div class="label"><span>{{ 'BILLING.INVOICES' | translate }}</span></div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Profile section hidden in billing sidebar -->
      <div></div>

    </div>
  </div>

  <!-- Main content -->
  <div class="billing-content">
    @if (activeView === 'overview') {
      <app-overview></app-overview>
    }
    @if (activeView === 'invoices') {
      <app-invoices></app-invoices>
    }
  </div>

</div>
